import {
    SET_PRICE,
    SET_STEP,
    SET_STEP_NUMBER,
    SET_STEP_AMOUNT,
    SET_SUB_STEP,
    SET_CHOICES,
    SET_POPUP,
    SET_LOADING,
    SET_SUCCESS,
    SET_SCROLL,
    SET_RESIZE,
    SET_KEY,
    SET_ADD_TO_CART_CHECK,
    SET_PAYMENTS,
    SET_NUMBEROFPAYMENTS
} from './actionTypes'

const Reducer = (state, action) => {
    switch (action.type) {
        case SET_PRICE: return { ...state, price: action.payload }
        case SET_STEP: return { ...state, step: action.payload }
        case SET_STEP_NUMBER: return { ...state, stepnumber: action.payload }
        case SET_STEP_AMOUNT: return { ...state, stepamount: action.payload }
        case SET_SUB_STEP: return { ...state, substep: action.payload }
        case SET_CHOICES: return { ...state, choices: action.payload }
        case SET_POPUP: return { ...state, popup: action.payload }
        case SET_LOADING: return { ...state, loading: action.payload }
        case SET_SUCCESS: return { ...state, success: action.payload }
        case SET_SCROLL: return { ...state, scroll: action.payload }
        case SET_RESIZE: return { ...state, resize: action.payload }
        case SET_KEY: return { ...state, key: action.payload }
        case SET_ADD_TO_CART_CHECK: return { ...state, addToCartCheck: action.payload }
        case SET_PAYMENTS: return {...state, payments: action.payload}
        case SET_NUMBEROFPAYMENTS: return {...state, numberOfPayments: action.payload}
        default: return state
    }
}

export default Reducer